var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CatBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('CatIntroduction'),_c('CatBenefits'),_c('CatDownload'),_c('CatBannerApp'),_c('CatContentView'),_c('CatContent'),_c('CatLogo'),_c('CatBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }